import { render, staticRenderFns } from "./WidthType.vue?vue&type=template&id=0d775da2&"
import script from "./WidthType.vue?vue&type=script&lang=js&"
export * from "./WidthType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports